import { Divider, Box } from '@cad-arc';
import { MapAssignedUnitInfo } from '@mark43/cad-api';
import { EventGeneralInfoBlock } from '../event-general-info-block';
import eventAssignedInactive from '../../../../esri/images/event-icons/assigned/event_assigned_inactive.svg';
import eventUnassignedInactive from '../../../../esri/images/event-icons/unassigned/event_unassigned_inactive.svg';
import { eventNotificationPriorityToColors } from '../../../../event-notifications/event-notifications';
import { CommonSize } from '../../../../common/helpers/utils';

type EventOverviewProps = {
    assignedUnits: MapAssignedUnitInfo[];
    priority?: string;
    agencyEventNumber?: string;
    cfsCode?: string;
    cfsDescription?: string;
    entityId: number;
    eventHasLocationNotification: boolean;
    size?: CommonSize;
};

export function EventOverview({
    assignedUnits,
    priority,
    agencyEventNumber,
    cfsCode,
    cfsDescription,
    entityId,
    eventHasLocationNotification,
    size,
}: EventOverviewProps): React.ReactElement {
    const blockBorderBottomColor = eventHasLocationNotification
        ? eventNotificationPriorityToColors['STANDARD'].notchOrText
        : 'transparent';

    const hasAssignedUnits = !!assignedUnits?.length;

    const eventIcon = hasAssignedUnits ? eventAssignedInactive : eventUnassignedInactive;

    return (
        <Box
            data-testid="MAP_EVENT_OVERVIEW_SECTION"
            borderBottomWidth="2px"
            borderBottomColor={blockBorderBottomColor}
        >
            <Box padding="12px 18px">
                <EventGeneralInfoBlock
                    eventIcon={eventIcon}
                    eventPriority={priority}
                    agencyEventNumber={agencyEventNumber}
                    cfsCode={cfsCode}
                    cfsDescription={cfsDescription}
                    eventId={entityId}
                    isAssigned={hasAssignedUnits}
                    size={size}
                />
            </Box>
            {!eventHasLocationNotification && <Divider />}
        </Box>
    );
}
